// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import './plugins/vuetify'
import App from './App'
import router from './router'
import jQuery from 'jquery'
import VueI18n from 'vue-i18n'
import messages from './assets/localization/localizations'

window.$ = global.jQuery = jQuery

// Vue.use(VueResource) // may not need
Vue.use(VueI18n)
Vue.use(VueCookies)

let lang = navigator.language.slice(0, 2)
if (lang !== 'en' && lang !== 'es' && lang !== 'pt' && lang !== 'fr') {
  lang = 'en'
}
const i18n = new VueI18n({
  locale: lang, // set locale, 'en' or 'es' so far
  'messages': messages.messages // set locale messages
})

window.i18n = i18n

$('html').attr('lang', lang)

Vue.config.productionTip = false

/* eslint-disable no-new */
window.mainvue = new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
